import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  title: 'Ansiedad y Estrés',
  desc: 'Cuando la mente no para y el cuerpo lo siente',
  img: 'https://images.unsplash.com/photo-1474418397713-7ede21d49118?w=400&q=80'
}, {
  title: 'Gestión de Emociones',
  desc: 'Aprender a sentir sin que te desborde',
  img: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=400&q=80'
}, {
  title: 'Relaciones en Conflicto',
  desc: 'Reconstruir vínculos desde la comprensión',
  img: 'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&q=80'
}, {
  title: 'Crecimiento Personal',
  desc: 'Descubrir tu mejor versión paso a paso',
  img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&q=80'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PainPoints() {
  return <section className="py-24 px-6 lg:px-12 max-w-7xl mx-auto" data-id="element-109" data-mp="27sz040tlvktu">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} data-id="element-110" data-mp="27s75otbqvt55">
        <h2 className="text-4xl md:text-5xl font-serif text-dark mb-4" data-id="element-111" data-mp="1p30juxfnmlf4">
          ¿Cómo te sientes hoy?
        </h2>
        <p className="text-medium text-lg max-w-2xl mx-auto" data-id="element-112" data-mp="1k34ofml0w2b6">
          Reconocer lo que nos pasa es el primer paso hacia el bienestar.
        </p>
      </motion.div>

      <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} data-id="element-113" data-mp="2vil18ttjga4h">
        {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} whileHover={{
        y: -5
      }} className="bg-crema-light rounded-3xl p-6 flex flex-col sm:flex-row items-center sm:items-start gap-6 shadow-neumorph transition-all duration-300 hover:shadow-neumorph-hover" data-id="element-114" data-mp="225bl3lp8thrf" data-mpi={index}>
            <div className="w-24 h-24 sm:w-32 sm:h-32 flex-shrink-0" data-id="element-115" data-mp="1egsa2yet6qvn">
              <img src={point.img} alt={point.title} className="w-full h-full object-cover rounded-2xl shadow-sm" data-id="element-116" data-mp="1jf3pdonvhtl9" />
            </div>
            <div className="flex flex-col justify-center h-full text-center sm:text-left" data-id="element-117" data-mp="qrg4e8iox0y3">
              <h3 className="text-2xl font-serif text-dark mb-2" data-id="element-118" data-mp="vp97utslzguo">
                {point.title}
              </h3>
              <p className="text-medium leading-relaxed" data-id="element-119" data-mp="o571gray470o">{point.desc}</p>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
}